module.exports = __webpack_public_path__ + "static/img/mac-tips.68e1d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mac-tips.png
// module id = 1310
// module chunks = 116